import React from "react";
import config from "../data/siteConfig";
import { GiCutDiamond } from "react-icons/gi";

const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");

// Karats shown in the marquee. Each value comes straight from the rate panel
// (backend) via its config key. `karat` is only used as a fallback to derive a
// figure from 24K if the backend hasn't supplied that karat yet (older data).
const KARATS = [
  ["24K", "gold24k", 24],
  ["22K", "gold22k", 22],
  ["20K", "gold20k", 20],
  ["18K", "gold18k", 18],
  ["14K", "gold14k", 14],
  ["9K", "gold9k", 9],
];

// round to the nearest ₹10 so any derived fallback figure reads cleanly
const round10 = (n) => Math.round(n / 10) * 10;

export default function RateBar({ rates }) {
  const base = Number(rates.gold24k) || 0;
  const karatRate = (key, karat) => {
    const v = Number(rates[key]);
    if (v > 0) return v; // value from the backend
    return round10((base * karat) / 24); // fallback derivation
  };

  const items = [
    `${config.marqueeTagline}`,
    `Today's Gold Rate (per 10g)`,
    ...KARATS.map(([label, key, karat]) => `${label} ${inr(karatRate(key, karat))}`),
    `Silver (per kg) ${inr(rates.silver)}`,
    `HM HUID Available`,
    `Rates updated on ${rates.updatedOn}`,
    `Visit us at Bhachau, Kutch`,
  ];

  // duplicate the strip so the loop is seamless
  const strip = (key) => (
    <div className="flex shrink-0 items-center" key={key}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center whitespace-nowrap px-6 text-[0.82rem] tracking-wide">
          <GiCutDiamond className="mr-2 text-gold-light" />
          {t}
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative z-[60] bg-coffee-grad text-cream border-b-2 border-gold/70 overflow-hidden paused">
      {/* live rate pill (fixed, solid so the marquee scrolls cleanly behind it) */}
      <div className="absolute inset-y-0 left-0 z-10 hidden items-center gap-3 bg-coffee-900 px-5 border-r border-gold/40 shadow-[8px_0_12px_rgba(28,16,9,0.5)] sm:flex">
        <span className="text-[0.72rem] uppercase tracking-widest text-gold-light">Live</span>
        <span className="text-[0.82rem]"><span className="opacity-70">22K</span> <b className="text-gold-light">{inr(rates.gold22k)}</b></span>
        <span className="text-[0.82rem]"><span className="opacity-70">24K</span> <b className="text-gold-light">{inr(rates.gold24k)}</b></span>
      </div>

      <div className="flex w-max animate-marquee anim-marquee py-2">
        {strip("a")}
        {strip("b")}
      </div>
    </div>
  );
}
